import Signal from "badmfck-signal";
import { UniversalDialogProps } from "./types";

class UniversalDialogSignal extends Signal<UniversalDialogProps | null> {
	private activeDialog: UniversalDialogProps | null = null
	private history: UniversalDialogProps[] = []

	override invoke(dialog: UniversalDialogProps | null) {
		if (!dialog) {
			this.activeDialog = null
			this.history = []
			super.invoke(null)
			return
		}

		if (this.activeDialog && this.activeDialog !== dialog) {
			this.history.push(this.activeDialog)
		}

		this.activeDialog = dialog
		super.invoke(dialog)
	}

	replace(dialog: UniversalDialogProps) {
		this.activeDialog = dialog
		super.invoke(dialog)
	}

	back() {
		const previousDialog = this.history.pop()
		if (!previousDialog) return false

		this.activeDialog = previousDialog
		super.invoke(previousDialog)
		return true
	}

	closeAll() {
		this.invoke(null)
	}

	hasActiveDialog() {
		return Boolean(this.activeDialog)
	}

	/**
	 * Lets the open dialog's content show a back chevron for its own in-place
	 * sub-views. Passing undefined restores the default history behaviour.
	 */
	setBackHandler(onBack: (() => void) | undefined) {
		if (!this.activeDialog) return
		if (this.activeDialog.onBack === onBack) return
		this.replace({ ...this.activeDialog, onBack })
	}

	isActiveDialog(dialog: UniversalDialogProps) {
		return this.activeDialog === dialog
	}

	canGoBack() {
		return this.history.length > 0
	}

	getHistoryDepth() {
		return this.history.length
	}

	handleSystemBack() {
		if (!this.activeDialog) return false

		if (this.back()) return true

		this.activeDialog.closeDialog()
		return true
	}
}

export const S_UNIVERSAL_DIALOG = new UniversalDialogSignal("S_UNIVERSAL_DIALOG");

export const closeUniversalDialog = () => S_UNIVERSAL_DIALOG.closeAll()

export const backUniversalDialog = () => S_UNIVERSAL_DIALOG.back()

export const handleUniversalDialogSystemBack = () =>
	S_UNIVERSAL_DIALOG.handleSystemBack()

export const replaceUniversalDialog = (dialog: UniversalDialogProps) =>
	S_UNIVERSAL_DIALOG.replace(dialog)

export const openNestedUniversalDialog = (
	createDialog: (onBack?: () => void) => UniversalDialogProps
) => {
	const hasPreviousDialog = S_UNIVERSAL_DIALOG.hasActiveDialog()
	const onBack = hasPreviousDialog ? backUniversalDialog : undefined
	const dialog = createDialog(onBack)

	S_UNIVERSAL_DIALOG.invoke(dialog)
}
